<template>
  <div class="goBack" :style="styleName" @click="goBack">
    <i class="el-icon-arrow-left"></i>
    返回
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'goBack',
  mixins: [init],
  data() {
    return {};
  },
  computed: {
    fontSize() {
      return this.option.fontSize || 30;
    },
    styleName() {
      return {
        textAlign: this.option?.textAlign,
        backgroundColor: this.option.backgroundColor,
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: this.fontSize + 'px',
        color: this.option.color || '#fff'
      };
    }
  },
  methods: {
    goBack() {
      this.gobackClick();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goBack {
}
</style>
